import { dtoToModel as userDtoToUserModel, modelToDto as userModelToUserDto } from '@hotjar/user';
import type {
  Organization as OrganizationDto,
  OrganizationMemberBaseInfo as OrganizationMemberBaseInfoDto,
} from './dto';
import type { Organization as OrganizationModel, OrganizationMemberBaseInfo } from './model';

export function mapOrganizationDtoToModel(organization: OrganizationDto): OrganizationModel {
  return {
    id: organization.id,
    name: organization.name,
    users: organization.users.map((organizationMember) => ({
      ...userDtoToUserModel(organizationMember),
      access: organizationMember.access,
    })),
    access: organization.access,
    accountAdminIds: organization.account_admin_ids,
    accountBillingStrategy: organization.account_billing_strategy,
    accountFeatures: organization.account_features,
    accountId: organization.account_id,
    alwaysOnRate: organization.always_on_rate,
    created: organization.created,
    effectivePlan: organization.effective_plan,
    features: organization.features,
    lockPlan: organization.lock_plan,
    nextPriceType: organization.next_price_type,
    percentageDiscount: organization.percentage_discount,
    plan: organization.plan,
    priceType: organization.price_type,
    sampleRate: organization.sample_rate,
    size: organization.size,
  };
}

export function mapOrganizationModelToDto(organization: OrganizationModel): OrganizationDto {
  return {
    id: organization.id,
    name: organization.name,
    users: organization.users.map((organizationMember) => ({
      ...userModelToUserDto(organizationMember),
      access: organizationMember.access,
    })),
    access: organization.access,
    account_admin_ids: organization.accountAdminIds,
    account_billing_strategy: organization.accountBillingStrategy,
    account_features: organization.accountFeatures,
    account_id: organization.accountId,
    always_on_rate: organization.alwaysOnRate,
    created: organization.created,
    effective_plan: organization.effectivePlan,
    features: organization.features,
    lock_plan: organization.lockPlan,
    next_price_type: organization.nextPriceType,
    percentage_discount: organization.percentageDiscount,
    plan: organization.plan,
    price_type: organization.priceType,
    sample_rate: organization.sampleRate,
    size: organization.size,
  };
}

export function mapOrganizationUserDtoToModel(
  user: OrganizationMemberBaseInfoDto,
): OrganizationMemberBaseInfo {
  return {
    id: user.user_id,
    name: user.user_name,
    avatar: user.user_picture_url,
  };
}
